module.exports = __webpack_public_path__ + "static/media/chatter.608a8359.svg";